import { PRICING_TYPES } from '../Constant';

/**
 * Primary lines = one labour main line (when it would render) + one per part main line.
 * Does not count optional description rows, part notes, or fee sub-rows.
 *
 * @param {object} service - Service row from API or form state
 * @param {{ variant: 'invoice-detail' | 'estimate-detail' | 'form' }} options
 * @returns {number}
 */
export function countPrimaryServiceLines(service, { variant }) {
    if (!service) return 0;

    const labor = service.labor ?? service.labour;
    let laborLine = 0;
    let partLines = 0;

    if (variant === 'invoice-detail') {
        if (service.pricingType === PRICING_TYPES.LABOUR && labor && Number(labor.qty) > 0) {
            laborLine = 1;
        }
        const parts = service.parts;
        partLines = Array.isArray(parts) ? parts.length : 0;
    } else if (variant === 'estimate-detail') {
        if (labor && Number(labor.qty) > 0) {
            laborLine = 1;
        }
        const parts = service.parts;
        partLines = Array.isArray(parts) ? parts.length : 0;
    } else if (variant === 'form') {
        if (service.pricingType === PRICING_TYPES.LABOUR) {
            const qtyMissing = service.qty === undefined || service.qty === null;
            const rateMissing = service.ratePerHour === undefined || service.ratePerHour === null;
            if (!qtyMissing && !rateMissing) {
                laborLine = 1;
            }
        }
        if (Array.isArray(service.parts)) {
            for (const p of service.parts) {
                const hasSelection = Boolean(p?.partName) || Boolean(p?._id) || Boolean(p?.inventoryId) || Boolean(p?.inventory?._id);
                if (p?.type === 'search' && !hasSelection) {
                    continue;
                }
                partLines += 1;
            }
        }
    }

    return laborLine + partLines;
}

/**
 * Per-service footer subtotal/total row: hidden for fixed price; for labour, shown when there are at least two primary lines (e.g. labour + part).
 *
 * @param {object} service
 * @param {{ variant: 'invoice-detail' | 'estimate-detail' | 'form' }} options
 * @returns {boolean}
 */
export function shouldShowPerServiceSubtotalRow(service, { variant }) {
    if (!service || service.pricingType === PRICING_TYPES.FXIED) {
        return false;
    }
    if (service.pricingType !== PRICING_TYPES.LABOUR) {
        return false;
    }
    return countPrimaryServiceLines(service, { variant }) >= 2;
}
